<template>
  <div style="height: 10px;display: flex;align-items: center">
    <v-divider />
  </div>
</template>
<script>
export default { name: 'FxDivider' }
</script>